"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpClient = void 0;
const tslib_1 = require("tslib");
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
const node_fetch_1 = tslib_1.__importDefault(require("node-fetch"));
class HttpClient {
    async get(url, options = {}) {
        var e_1, _a;
        var _b;
        const { timeout = 30000, progress } = options;
        const res = await (0, node_fetch_1.default)(url, {
            redirect: "follow",
            follow: (_b = options.maxRedirects) !== null && _b !== void 0 ? _b : 5,
            timeout,
        });
        if (!res.ok) {
            throw new Error(`Request failed with status ${res.status}`);
        }
        const totalSize = parseInt(res.headers.get("content-length") || "0", 10);
        let downloaded = 0;
        const chunks = [];
        try {
            for (var _c = tslib_1.__asyncValues(res.body), _d; _d = await _c.next(), !_d.done;) {
                const chunk = _d.value;
                chunks.push(chunk);
                downloaded += chunk.length;
                if (progress) {
                    progress(downloaded, totalSize);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) await _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        const buffer = Buffer.concat(chunks);
        return buffer;
    }
    async getText(url, options = {}) {
        const buffer = await this.get(url, options);
        return buffer.toString("utf-8");
    }
    async headTime(url, options = {}) {
        const { timeout = 30000 } = options;
        const startTime = Date.now();
        const res = await (0, node_fetch_1.default)(url, {
            method: "HEAD",
            timeout,
        });
        if (!res.ok) {
            throw new Error(`Request failed with status ${res.status}`);
        }
        return Date.now() - startTime;
    }
}
exports.httpClient = new HttpClient();
//# sourceMappingURL=httpClient.js.map